import type { ConfigState } from '@common/Checkout/Checkout/types/config';
import type { ConfigReducer } from '@common/Checkout/Checkout/types/reducers';
import { SET_CONFIG } from '../actions/constants';

const initialState: ConfigState = {
    shippingIcons: [],
    paymentIcons: [],
    footerIcons: [],
    shippingOptionsLimit: null,
    paymentOptionsLimit: null,
    phonePrefixes: [],
    termsAndConditionsLabel: '',
    subscriptionLabel: '',
    crossSubscriptionLabel: '',
    cancellationArticle: {
        title: '',
        content: '',
    },
    deliveryArticle: {
        title: '',
        content: '',
    },
    privacyArticle: {
        title: '',
        content: '',
    },
    termsArticle: {
        title: '',
        content: '',
    },
    shippingListOptionsLimit: [],
    paymentListOptionsLimit: [],
    labels: {
        clubSignUpDescription: {
            text: '',
            arguments: [],
        },
        clubSignUpLabel: {
            text: '',
            arguments: [],
        },
        subscription: {
            text: '',
            arguments: [],
        },
        subscriptionKids: {
            text: '',
            arguments: [],
        },
        crossSubscription: {
            text: '',
            arguments: [],
        },
        termsAndConditions: {
            text: '',
            arguments: [],
        },
        softOptIn: null,
    },
    isLoaded: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer: ConfigReducer = (state = initialState, action: any) => {
    const { type } = action;

    switch (type) {
        case SET_CONFIG: {
            const { payload } = action;
            return { ...state, ...payload, isLoaded: true };
        }

        default:
            return state;
    }
};

export default reducer;
